// extracted by mini-css-extract-plugin
module.exports = {"link":"_3zbyE","RibbonButton":"_1p-pr","ribbonButton":"_1p-pr","label":"_3schW","tri":"_3RFbD","tail":"aujWa"};